module.exports = __webpack_public_path__ + "img/wchgz-black-text.7e7515b4.png";